module.exports = __webpack_public_path__ + "static/media/chara_chaaa.94cdf8e5.ogg";